import React from "react";
import { Form, InputNumber, Select, Divider, Input } from "antd";

const moneyProps = {
  style: { width: "100%" },
  min: 0,
  formatter: (v) => v && `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
  parser: (v) => v.replace(/,/g, ""),
};

export default function CompareSection({ savingsType }) {
  return (
    <>
      <Form.Item label="Бодит хүү — сарын (%)">
        <div style={{ display: "flex", gap: 8 }}>
          <Form.Item name="minMonthlyEffectiveRate" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.01}
              placeholder="Хамгийн бага"
            />
          </Form.Item>
          <span style={{ lineHeight: "32px", color: "#999" }}>–</span>
          <Form.Item name="maxMonthlyEffectiveRate" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.01}
              placeholder="Хамгийн их"
            />
          </Form.Item>
        </div>
      </Form.Item>

      <Form.Item label="Бодит хүү — жилийн (%)">
        <div style={{ display: "flex", gap: 8 }}>
          <Form.Item name="minAnnualEffectiveRate" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.01}
              placeholder="Хамгийн бага"
            />
          </Form.Item>
          <span style={{ lineHeight: "32px", color: "#999" }}>–</span>
          <Form.Item name="maxAnnualEffectiveRate" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.01}
              placeholder="Хамгийн их"
            />
          </Form.Item>
        </div>
      </Form.Item>

      <Form.Item name="orderFee" label="Захиалгын шимтгэл (₮)">
        <InputNumber {...moneyProps} placeholder="0" />
      </Form.Item>

      <Form.Item name="accountOpeningFee" label="Данс нээх хураамж (₮)">
        <InputNumber {...moneyProps} placeholder="0" />
      </Form.Item>

      <Form.Item
        name="passbookFee"
        label="Хадгаламжийн дэвтэр нээх хураамж (₮)"
      >
        <InputNumber {...moneyProps} placeholder="3,000" />
      </Form.Item>

      <Form.Item name="accountClosingFee" label="Данс хаах хураамж (₮)">
        <InputNumber {...moneyProps} placeholder="3,000" />
      </Form.Item>

      <Form.Item
        name="earlyTerminationInterestRate"
        label="Гэрээ цуцлах үед тооцох хүү (%)"
      >
        <InputNumber
          style={{ width: "100%" }}
          min={0}
          step={0.01}
          placeholder="0"
        />
      </Form.Item>

      <Form.Item name="earlyWithdrawalFee" label="Эрт буцаан авах шимтгэл (%)">
        <InputNumber
          style={{ width: "100%" }}
          min={0}
          step={0.1}
          placeholder="0"
        />
      </Form.Item>

      <Form.Item name="interestPayoutSchedule" label="Хүү зарлагадах хугацаа">
        <Input placeholder="Жишээ: Сар бүрийн данс нээсэн өдөр" />
      </Form.Item>

      {/* {savingsType === "TERM" && (
        <Divider
          orientation="left"
          plain
          style={{ fontSize: 12, color: "#888" }}
        >
          Хугацаатай хадгаламж — нэмэлт
        </Divider>
      )}

      {savingsType === "CERTIFICATE" && (
        <Divider
          orientation="left"
          plain
          style={{ fontSize: 12, color: "#888" }}
        >
          Сертификат — нэмэлт
        </Divider>
      )} */}
    </>
  );
}
